document.addEventListener('DOMContentLoaded', () => {

  /*
   * =========================================
   * PAGE DETECTION
   * =========================================
   */

  let path = window.location.pathname;

  if (path.length > 1) {
    path = path.replace(/\/+$/, '');
  }

  const isTopPage = path === '/';

  document.body.classList.toggle(
    'top',
    isTopPage
  );


  /*
   * =========================================
   * ELEMENTS
   * =========================================
   */

  const announcementBar = document.querySelector(
    '#shopify-section-announcement-bar'
  );

  const stickyHeader = document.querySelector(
    'sticky-header > header'
  );

  const logo = document.querySelector(
    '.header__heading-logo'
  );

  if (!stickyHeader) return;


  /*
   * =========================================
   * LOGOS
   * TOP PAGE ONLY
   * =========================================
   */

  const whiteLogoSrc =
    '//gypsophila.shop/cdn/shop/files/gypsophila-logo-white_120x.png?v=1786604140';

  const whiteLogoSrcset =
    '//gypsophila.shop/cdn/shop/files/gypsophila-logo-white_120x.png?v=1786604140 1x, ' +
    '//gypsophila.shop/cdn/shop/files/gypsophila-logo-white_120x@2x.png?v=1786604140 2x';

  const blackLogoSrc =
    '//gypsophila.shop/cdn/shop/files/gypsophila-logo-black_120x.png?v=1786604140';

  const blackLogoSrcset =
    '//gypsophila.shop/cdn/shop/files/gypsophila-logo-black_120x.png?v=1786604140 1x, ' +
    '//gypsophila.shop/cdn/shop/files/gypsophila-logo-black_120x@2x.png?v=1786604140 2x';


  /*
   * =========================================
   * VISIBILITY
   * =========================================
   */

  const isAnnouncementBarVisible = () => {
    if (!announcementBar) return false;

    const style =
      window.getComputedStyle(announcementBar);

    return (
      announcementBar.getClientRects().length > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  };


  /*
   * =========================================
   * MEASURE FIXED ELEMENTS
   * =========================================
   */

  const updateLayoutMeasurements = () => {

    const announcementHeight =
      isAnnouncementBarVisible()
        ? announcementBar.getBoundingClientRect().height
        : 0;

    const headerHeight =
      stickyHeader.getBoundingClientRect().height;


    /*
     * Available globally to CSS
     */
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      `${announcementHeight}px`
    );

    document.documentElement.style.setProperty(
      '--header-height',
      `${headerHeight}px`
    );
  };


  /*
   * =========================================
   * LOGO
   * TOP PAGE ONLY
   * =========================================
   */

  const updateLogo = (isScrolled) => {
    if (!isTopPage || !logo) return;

    if (isScrolled) {

      logo.setAttribute(
        'src',
        blackLogoSrc
      );

      logo.setAttribute(
        'srcset',
        blackLogoSrcset
      );

    } else {

      logo.setAttribute(
        'src',
        whiteLogoSrc
      );

      logo.setAttribute(
        'srcset',
        whiteLogoSrcset
      );
    }
  };


  /*
   * =========================================
   * SCROLL STATE
   * TOP PAGE ONLY
   * =========================================
   */

  const updateHeaderOnScroll = () => {
    if (!isTopPage) return;

    const scrollThreshold =
      window.innerHeight * 0.1;

    const isScrolled =
      window.scrollY > scrollThreshold;


    /*
     * Header
     */
    stickyHeader.classList.toggle(
      'header--scrolled',
      isScrolled
    );


    /*
     * Announcement
     */
    if (announcementBar) {
      announcementBar.classList.toggle(
        'announcement-bar--scrolled',
        isScrolled
      );
    }


    /*
     * Logo
     */
    updateLogo(isScrolled);


    /*
     * Header height changes when compact,
     * so measure it again.
     */
    requestAnimationFrame(() => {
      updateLayoutMeasurements();
    });
  };


  /*
   * =========================================
   * INITIAL SETUP
   * =========================================
   */

  updateLayoutMeasurements();

  if (isTopPage) {
    updateHeaderOnScroll();
  }


  /*
   * =========================================
   * RESIZE OBSERVERS
   * =========================================
   */

  const resizeObserver = new ResizeObserver(() => {
    updateLayoutMeasurements();
  });

  resizeObserver.observe(stickyHeader);

  if (announcementBar) {
    resizeObserver.observe(announcementBar);
  }


  /*
   * =========================================
   * WINDOW RESIZE
   * =========================================
   */

  window.addEventListener(
    'resize',
    () => {
      updateLayoutMeasurements();

      if (isTopPage) {
        updateHeaderOnScroll();
      }
    }
  );


  /*
   * =========================================
   * SCROLL
   * =========================================
   */

  if (isTopPage) {
    window.addEventListener(
      'scroll',
      updateHeaderOnScroll,
      {
        passive: true
      }
    );
  }
});